/* eslint-disable */
import React, { useMemo } from 'react';

import { useGetTableLayout } from '../../hooks';
import { useTranslate } from '../../../../../../../../hooks';
import { useListEmployeeRoster } from '../../api';

import {
  AllRowsSelectedType,
  AssignedEmployeeShiftListType,
  CustomBodyRenderType,
} from '../../types';
import { Day } from '../../../types';

import '../current-employee-shift-list/CurrentEmployeeShiftList.css';

import DefaultTableBodyCell from '../../../../../../../../components/table/DefaultTableBodyCell';
import { Backdrop, Table } from '../../../../../../../../components';
import { EmpNameCard, ShiftTImeColumn, DateColumn, EmptyList } from '../common';
import moment from 'moment';

export function AssignedEmployeeShiftList({
  selectedEmployee,
  handleSelectShift,
  selectedShifts,
  startDate,
  days,
}: AssignedEmployeeShiftListType) {
  const { translate } = useTranslate();
  const { layout } = useGetTableLayout({ type: 1 });

  const { data, isLoading } = useListEmployeeRoster({
    params: {
      days,
      employeeId: selectedEmployee?.id,
      startDate,
    },
    config: {
      enabled: !!selectedEmployee?.id,
    },
  });

  const columns = useMemo(
    () => [
      {
        name: 'date',
        label: translate('Date'),
        options: {
          customBodyRender: (value: CustomBodyRenderType) => {
            return <DateColumn value={value} />;
          },
        },
      },
      {
        name: 'shiftTime',
        label: translate('Time'),
        options: {
          customBodyRender: (value: CustomBodyRenderType) => {
            return <ShiftTImeColumn value={value} />;
          },
        },
      },
      {
        name: 'code',
        label: translate('Shift Code'),
        options: {
          customBodyRender: (value: CustomBodyRenderType) => {
            return (
              <DefaultTableBodyCell
                value={value?.code}
                className={`current-emp-shift-code-cell ${
                  value?.isToday && 'font-success'
                }`}
              />
            );
          },
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const tableData = useMemo(() => {
    const res = data?.shifts?.map((item: Day) => {
      return {
        date: { date: item?.date, isToday: moment().isSame(item?.date, 'day') },
        shiftTime: {
          startTime: item.startTime,
          endTime: item.endTime,
          isFlexi: item.isFlexi,
          isHoliday: item.isHoliday,
          isOvernight: item.isOvernight,
          isWeekOff: item.isWeekOff,
          onLeave: item.isLeave,
          code: item.code,
        },
        code: { code: item.code, isToday: moment().isSame(item?.date, 'day') },
      };
    });

    return res;
  }, [data]);

  const handleSelect = (
    currentRowsSelected: any[],
    allRowsSelected: any[],
    rowsSelected?: any[],
  ) => {
    interface MyObject {
      [key: string | number]: Day;
    }

    const newAllSelected: MyObject = {};

    allRowsSelected?.forEach((row: AllRowsSelectedType) => {
      newAllSelected[`${row?.dataIndex}`] = tableData[row?.dataIndex];
    });
    if (handleSelectShift) {
      handleSelectShift({
        shifts: newAllSelected,
      });
    }
  };

  return (
    <>
      <div className="current-emp-shift">
        {selectedEmployee ? (
          <>
            <p className="current-emp-shift-title">
              {translate('Select Shift')}
            </p>
            <EmpNameCard
              empName={selectedEmployee?.name}
              designation={selectedEmployee?.designation}
              containerClassName="current-emp-shift-name-card-container"
              profilePic={selectedEmployee?.profileImage}
            />
            <div className="shift-swap">
              <Table
                columns={columns}
                data={tableData || []}
                count={0}
                options={{
                  pagination: false,
                  selectableRows: 'multiple',
                  selectableRowsHeader: true,
                  ...layout,
                  selectToolbarPlacement: 'none',
                  rowsSelected: selectedShifts,
                  onRowSelectionChange: handleSelect,
                }}
              />
            </div>
          </>
        ) : (
          <EmptyList
            title={`${translate('Empty Slot')}`}
            message={`${translate(`You didn't select any employee, Please select employee and continue
            with shift and schedule`)}`}
          />
        )}
      </div>

      <Backdrop open={isLoading} />
    </>
  );
}
